module.exports = __webpack_public_path__ + "static/bishop-homepage-logo-d6ed2279302d8840b73949f180db434e.png";